import type { PlanType } from './plan';
import {
  getPlanTypeTitle,
  PLAN_TYPE_TITLE_KEYS,
  type PlanTypeTitleSetting,
} from './setting';

export interface PlanTypeNameConfigItem {
  planType: PlanType;
  title: string;
}

function mapPlanTypeTitleToItems(
  data?: PlanTypeTitleSetting,
): PlanTypeNameConfigItem[] {
  if (!data) {
    return [];
  }

  return PLAN_TYPE_TITLE_KEYS.map((planType) => {
    const title = data[planType]?.trim();
    if (!title) {
      return null;
    }
    return { planType: planType as PlanType, title };
  }).filter((item): item is PlanTypeNameConfigItem => item !== null);
}

export async function getPlanTypeNameConfig() {
  const data = await getPlanTypeTitle();
  return {
    list: mapPlanTypeTitleToItems(data),
    updateAt: data?.updateAt,
    updateUserName: data?.updateUser?.displayName,
  };
}
